import ApiService from "../../services/ApiService";

export async function listTutorStories() {
    const result = await ApiService.getData("/v1/user/tutor-stories");
    if (Array.isArray(result)) {
        return result;
    }
    if (Array.isArray(result?.data)) {
        return result.data;
    }
    return [];
}

export async function listTutorClueLog(cloudUserId) {
    const params = cloudUserId ? { cloudUserId } : undefined;
    const result = await ApiService.getData("/v1/tutor/clue-log", params);
    if (Array.isArray(result)) {
        return result;
    }
    if (Array.isArray(result?.data)) {
        return result.data;
    }
    return [];
}
